import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Avatar,
  Divider,
  ButtonBase,
  Typography,
  Menu,
  MenuItem,
  styled,
} from "@mui/material";

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  marginLeft: 8,
  borderRadius: 30,
  padding: 4,
  border: `1px solid ${theme.palette.grey[200]}`,
  "&:hover": { backgroundColor: theme.palette.action.hover },
}));

export default function ProfilePopover() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  // Dohvaćanje podataka spremljenih pri login-u
  const userName = localStorage.getItem("name") || "Korisnik";
  const userEmail = localStorage.getItem("email") || "email@g3spirits.com";

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    localStorage.clear(); // Briše token, user_id, tvrtka_id...
    navigate("/"); // Vraća na login
  };

  return (
    <>
      <StyledButtonBase onClick={handleOpen}>
        <Avatar
          sx={{ width: 32, height: 32, fontSize: "1rem", bgcolor: "#284c7a" }}
        >
          {userName.charAt(0).toUpperCase()}
        </Avatar>
      </StyledButtonBase>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        // ZAMJENA: Umjesto PaperProps koristimo slotProps.paper
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: 220,
              mt: 1.5,
              borderRadius: "12px", // Moderniji zaobljeni rubovi
              overflow: "visible",
              filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.1))",
              border: "1px solid rgba(0,0,0,0.08)",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box px={2.5} py={2}>
          <Typography
            variant="subtitle2"
            fontWeight="700"
            color="text.primary"
            noWrap
          >
            {userName}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ display: "block" }}
          >
            {userEmail}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem
          onClick={handleLogout}
          sx={{
            py: 1.5,
            px: 2.5,
            color: "error.main",
            fontWeight: 600,
            fontSize: "0.875rem",
            "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.04)" },
          }}
        >
          Odjavite se
        </MenuItem>
      </Menu>
    </>
  );
}
